@if (!inIframe()) {
  <button type="button" nativeCursor id="leave-room" mat-raised-button class="button v1" (click)="leave()">
    LEAVE
  </button>
}
